import { Controller } from "@hotwired/stimulus"

// Disables submit button and shows loading text on form submit (replaces Rails UJS disable_with).
export default class extends Controller {
  static values = { disableWith: { type: String, default: "Processing…" } }

  connect() {
    this.element.addEventListener("submit", this.disableOnSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("submit", this.disableOnSubmit.bind(this))
  }

  disableOnSubmit() {
    const btn = this.element.querySelector('input[type="submit"], button[type="submit"]')
    if (!btn || btn.disabled) return
    btn.disabled = true
    if (btn.tagName === "INPUT") {
      btn.value = this.disableWithValue
    } else {
      btn.textContent = this.disableWithValue
    }
  }
}
